<div
  class="template-tile"
  [class]="{ 'template-hover': enableHover && tileHover }"
  (mouseover)="tileHover = enableHover && true"
  (mouseleave)="tileHover = enableHover && false"
>
  <div class="template-tile-content">
    <div class="tile-title">{{ template.name }}</div>
    <div class="tile-description">{{ template.description }}</div>
    <hr />
    <div class="tile-demos">
      <div class="demo-title">included demos</div>
      <div class="demo-container">
        <div class="demo" *ngFor="let asset of template.relatedDemoAssets">
          <span class="demo-dot">&#x2022;</span>
          <span class="demo-text">{{ asset.default ? "Default - " + asset.name : asset.name }}</span>
          <mat-icon svgIcon="info-16" (click)="infoButtonClick($event, asset)"></mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div class="template-tile-button" *ngIf="enableAction">
    <brd-button
      text="create demo instance"
      [color]="tileHover ? 'primary' : 'secondary'"
      iconName="plus-16"
      (clickEvent)="createInstanceClick($event)"
    ></brd-button>
  </div>
</div>

<ng-template #completeDialog let-data="data">
  <div class="dialog-container">
    <div class="text">
      Your Demo Instance is being set up and may take from 5 to 30 minutes to complete, depending on the instance size. You can check its
      progress in the Active Demo Environments section. When complete, you'll get an email notification.
    </div>
    <div class="button">
      <brd-button text="OK" color="primary" (clickEvent)="closeDialog()"></brd-button>
    </div>
  </div>
</ng-template>
